import React, { useContext, useState, useEffect } from "react";
import { closeModal } from "@redq/reuse-modal";
import TextField from "../../../components/TextField/TextField";
import Button from "../../../components/Button/Button";
import { Heading } from "../../CheckoutWithSidebar/Update/Update.style";
import Select from 'react-select';
import countryCodes from "../../../data/nationalities.json";
import { Typography } from "@material-ui/core";
const UpdateProfile = (props) => {
  let user = localStorage.getItem("user");
  let parsedUser = JSON.parse(user);
  const [first_name, setFirstName] = useState(parsedUser.first_name);
  const [email, setEmail] = useState(parsedUser.email);
  const [last_name, setLastName] = useState(parsedUser.last_name);
  const [mobile_number, setMobile] = useState(parsedUser.phone);
  const [country_code, setCountry_code] = useState(parsedUser.country_code);
  const [nationality, setNationality] = useState(parsedUser?.nationality||"undefined");
  const [allnations, setAllNations] = React.useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    let body = {
      cust_id: parsedUser.cust_id,
      first_name,
      last_name,
      phone: mobile_number,
      email,
      country_code,
      nationality:nationality
    };
    props.props.updateProfile(body);
    closeModal();
  };

  const ccodes = () => {
     const nations = countryCodes.map((country_code)=>{
       return {
         value: country_code.nationality === "I'd rather not share" ? null : country_code.nationality,
         label: country_code.nationality
       }
     });
     setAllNations(nations);
   };

   useEffect(() => {
    ccodes();
  },[]);

  function isNumber(evt) {
    let telephone = evt.target.value;
    let regexp = /^[0-9\+\b]+$/;
    if (regexp.test(telephone)) {
      setMobile(telephone);
    }
  }

  const handleSelectNationally = (value) => {
    console.log(value);
    if (value !== "") {
      setNationality(value.value);
    }
  };

  return (
    <>
      <form style={{height:"auto"}}>
        <Heading>
          {props.type !== "add" ? "Edit Profile" : "Edit Profile"}
        </Heading>

        <div className="row">
          <div className="col-sm-6 pb-2 pr-0">
          <Typography variant="p" component="p" gutterBottom>
            First Name
          </Typography>
            <TextField
              type="text"
              placeholder="First Name"
              value={first_name}
              onChange={(e) => {
                setFirstName(e.target.value);
              }}
            />
          </div>
          <div className="col-sm-6">
          <Typography variant="p" component="p" gutterBottom>
            Last Name
          </Typography>
            <TextField
              type="text"
              placeholder="Last Name"
              value={last_name}
              onChange={(e) => {
                setLastName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3 pb-2">
          <Typography variant="p" component="p" gutterBottom>
              Country Code
            </Typography>
            <TextField
              type="text"
              value={country_code}
              onChange={(e) => {
                setCountry_code(e.target.value);
              }}
            />
          </div>
          <div className="col-sm-9 pb-3">
          <Typography variant="p" component="p" gutterBottom>
            Phone
          </Typography>
            <TextField
              type="text"
              placeholder="Mobile"
              value={mobile_number}
              onChange={(e) => {
                setMobile(e.target.value);
              }}
              maxLength={14}
            />
          </div>
          <div className="col-sm-12">
          <Typography variant="p" component="p" gutterBottom>
            Email
          </Typography>
            <TextField
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              disabled
            />
          </div>
          <div className="col-sm-12 mb-2 mt-2">
          <Typography variant="p" component="p" gutterBottom>
            Nationality
          </Typography>
            <Select
              className={`cc ${props.cartType}`}
              classNamePrefix="select"
              placeholder="Nationality"
              name="nationality"
              options={allnations}
              value={allnations.find((country) => country.label === nationality)}
              onChange={(value) => handleSelectNationally(value)}
              style={{zIndex:'9999'}}
            />
          </div>
        </div>

        <Button
          onClick={handleSubmit}
          type="submit"
          title="Save"
          size="medium"
          fullwidth={true}
          style={{ marginBottom: 15 }}
        />
      </form>
    </>
  );
};
export default UpdateProfile;
